(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[536],{

/***/ 4658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial_team",
      function () {
        return __webpack_require__(5398);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ editorial_team; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/editorial_team/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n padding: 2vh 2vw;\n border-top: 1px solid #ddd;\n\n @media (max-width: 426px) {\n  padding: 2vh 4vw 3vh;\n }\n\n section {\n  & + section {\n   margin-top: 2vh;\n  }\n\n  h4 {\n   font-variant: small-caps;\n   font-stretch: 110%;\n   color: #f70;\n  }\n\n  @media (min-width: 427px) {\n   p {\n    line-height: 1.7;\n   }\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-924177b4-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/editorial_team/index.tsx





var description = 'Pessoas que fazem parte da equipe da Revista Aufkl\xe4rung.';
var title = 'Equipe Editorial';
var EditorialTeam = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Editor"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:blsic@hotmail.com",
                                        children: "Prof. Dr. Betto Leite da Silva"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Editores Associados"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:andersondarc@uai.com.br",
                                        children: "Prof. Dr. Anderson D'Arc Ferreira"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jlubenow@hotmail.com",
                                        children: "Prof. Dr. Jorge Adriano Lubenow"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:robsonccordeiro@bol.com.br",
                                        children: "Prof. Dr. Robson Costa Cordeiro"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Editor de Design Gr\xe1fico e Editora\xe7\xe3o Eletr\xf4nica"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:hyoretsu@gmail.com",
                                        children: "Aran Leite de Gusm\xe3o"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Conselho Editorial"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:andersondarc@uai.com.br",
                                        children: "Prof. Dr. Anderson D'Arc Ferreira"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:angmich@tin.it",
                                        children: "Profa. Dra. Angela Michelis"
                                    }),
                                    ", University of Turin, UNITO, Italy"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:iulianapostu76@gmail.com",
                                        children: "Prof. Dr. Apostu Iulian"
                                    }),
                                    ", University of Bucharest, UniBuc, Romania"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:campillo@um.es",
                                        children: "Prof. Dr. Antonio Campillo Meseguer"
                                    }),
                                    ", Universidad de Murcia, Spain"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:blsic@hotmail.com",
                                        children: "Prof. Dr. Betto Leite da Silva"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:candida.jaci@gmail.com",
                                        children: "Profa. Dra. Candida Jaci de Sousa Melo"
                                    }),
                                    ", Universit\xe9 du Quebec \xe0 Montr\xe9al/UFPB, Canada"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Prof. Dr. Carlos Emilio Garcia Duque, Universidad de Caldas, Colombia"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jlubenow@hotmail.com",
                                        children: "Prof. Dr. Jorge Adriano Lubenow"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:djvdutra@yahoo.com.br",
                                        children: "Prof. Dr. Delamar Jos\xe9 Volpato Dutra"
                                    }),
                                    ", Universidade Federal de Santa Catarina, UFSC, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Prof. Dr. Ernildo J. Stein, Pontif\xedcia Universidade Cat\xf3lica do Rio Grande do Sul, PUCRS, Brazil"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:mariusesi@yahoo.com",
                                        children: "Prof. Dr. Esi Marius Costel"
                                    }),
                                    ", Stefan cel Mare University of Suceava, USV, Romania"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:gianluca.garelli@unifi.it",
                                        children: "Prof. Dr. Gianluca Garelli"
                                    }),
                                    ", Universit\xe0 degli Studi di Firenze, UniFI, Italy"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Prof. Dr. Giovanni da Silva Queiroz, Universidade Federal da Para\xedba, UFPB, Brazil"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:brunkhorst@uni-flensburg.de",
                                        children: "Prof. Dr. Hauke Brunkhorst"
                                    }),
                                    ", Europa-Universit\xe4t Flensburg, EUF, Germany"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:signus@ufpi.edu.br",
                                        children: "Prof. Dr. Helder Buenos Aires de Carvalho"
                                    }),
                                    ", Universidade Federal do Piau\xed, UFPI, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jelson.oliveira@pucpr.br",
                                        children: "Prof. Dr. Jelson Roberto de Oliveira"
                                    }),
                                    ", Pontif\xedcia Universidade Cat\xf3lica do Paran\xe1, PUCPR, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jlubenow@hotmail.com",
                                        children: "Prof. Dr. Jorge Adriano Lubenow"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jtrin41@gmail.com",
                                        children: "Prof. Dr. Jos\xe9 G. Trindade Santos"
                                    }),
                                    ", Universidade Federal da Para\xedba, UFPB, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:jper@ufrgs.br",
                                        children: "Prof. Dr. Jos\xe9 Pinheiro Pertille"
                                    }),
                                    ", Universidade Federal do Rio Grande do Sul, UFRGS, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:lblaraujo@gmail.com",
                                        children: "Prof. Dr. Luis Bernardo Leite Ara\xfajo"
                                    }),
                                    ", Universidade Estadual do Rio de Janeiro, UERJ, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Prof. Dr. Luiz Felipe N. A. S. Sahd, Universidade Federal do Cear\xe1, UFC, Brazil"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:luizrouanet@terra.com.br",
                                        children: "Prof. Dr. Luiz Paulo Rouanet"
                                    }),
                                    ", Universidade Federal de S\xe3o Jo\xe3o del-Rei, UFSJ, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:carvalho.marcelo@uol.com.br",
                                        children: "Prof. Dr. Marcelo Silva Carvalho"
                                    }),
                                    ", Universidade Federal de S\xe3o Paulo, Unifesp, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:massimo.mori@unito.it",
                                        children: "Prof. Dr. Massimo Mori"
                                    }),
                                    ", Universit\xe0 di Torino, UNITO, Italy"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:gonzalezvalerio@gmail.com",
                                        children: "Profa. Dra. Mar\xeda Antonia Gonz\xe1lez Valerio"
                                    }),
                                    ", Universidad Nacional Aut\xf3noma de M\xe9xico, UNAM, Mexico"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Profa. Dra. Maria das Gra\xe7as de Souza, Universidade de S\xe3o Paulo, USP, Brazil"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:nythamar.oliveira@pucrs.br",
                                        children: "Prof. Dr. Nythamar F. de Oliveira"
                                    }),
                                    ", Pontif\xedcia Universidade Cat\xf3lica do Rio Grande do Sul, PUCRS, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:wellistony_carvalho@hotmail.com",
                                        children: "Prof. Dr. Wellistony Carvalho Viana"
                                    }),
                                    ", Universidade Federal do Piau\xed, UFPI, Brazil"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "mailto:wmaar@ufscar.br",
                                        children: "Prof. Dr. Wolfgang Leo Maar"
                                    }),
                                    ", Universidade Federal de S\xe3o Carlos, UFSCar, Brazil"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var editorial_team = (EditorialTeam);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(4658); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);